export * from './dictum';
